
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.941 5a.744.744 0 00-.258.044L.468 9.477a.732.732 0 000 1.366l3.708 1.463v3.857a1.876 1.876 0 00.814 1.428 6.325 6.325 0 001.7.963 15.053 15.053 0 0010.526 0 6.355 6.355 0 001.7-.963 1.883 1.883 0 00.814-1.428v-3.857l1.4-.552v2.364l-.019.014a1.245 1.245 0 00-.5.988 1.255 1.255 0 002.509 0 1.248 1.248 0 00-.5-.988l-.02-.014v-2.945l.838-.33a.732.732 0 000-1.366l-11.22-4.43A.894.894 0 0011.941 5zm.01 13.039a13.012 13.012 0 01-4.705-.844 5.266 5.266 0 01-1.318-.732 1.231 1.231 0 01-.256-.282l-.01-.016h-.023v-3.277l.068.027 5.975 2.364a.737.737 0 00.533 0l6.043-2.391v3.274l-.018.011-.009.012a1.343 1.343 0 01-.259.28 5.28 5.28 0 01-1.318.732 13.008 13.008 0 01-4.703.842zm0-4.235l-9.224-3.64 9.224-3.648.018.007 9.205 3.641-.117.047z"}})])
          )
        }
      }
    